import * as R from "ramda";

/**
 * Determine if a type is nil (null / undefined) or empty ({} / []).
 */
export const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
